export type KeyType = "azure" | "aws_bedrock" | "google_vertex" | "other";

export const KEY_TYPE_OPTIONS: { value: KeyType; label: string }[] = [
  { value: "azure", label: "Azure" },
  { value: "aws_bedrock", label: "AWS Bedrock" },
  { value: "google_vertex", label: "Google Vertex" },
  { value: "other", label: "Other" },
];

export interface OpenRouterKeyFormState {
  id?: string;
  keyType: KeyType | "";
  // Azure
  modelSlug: string;
  endpointUrl: string;
  apiKey: string;
  modelId: string;
  // AWS Bedrock
  key: string; // also used by Other
  accessKeyId: string;
  secretAccessKey: string;
  region: string; // also used by Google Vertex
  // Google Vertex
  modelType: string;
  projectId: string;
  privateKeyId: string;
  privateKey: string;
  clientEmail: string;
  clientId: string;
  authUri: string;
  tokenUri: string;
  authProviderX509CertUrl: string;
  clientX509CertUrl: string;
  universeDomain: string;
}

export const INITIAL_FORM_STATE: OpenRouterKeyFormState = {
  keyType: "",
  modelSlug: "",
  endpointUrl: "",
  apiKey: "",
  modelId: "",
  key: "",
  accessKeyId: "",
  secretAccessKey: "",
  region: "",
  modelType: "",
  projectId: "",
  privateKeyId: "",
  privateKey: "",
  clientEmail: "",
  clientId: "",
  authUri: "",
  tokenUri: "",
  authProviderX509CertUrl: "",
  clientX509CertUrl: "",
  universeDomain: "",
};
